import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoYouTube = () => {
  return (
    <g>
      <path d="m15.5361 4.1894a1.9764 1.9764 0 0 0 -1.3906-1.4 46.7 46.7 0 0 0 -6.1455-.3305 46.7 46.7 0 0 0 -6.1454.3311 1.9764 1.9764 0 0 0 -1.3906 1.4 20.7343 20.7343 0 0 0 -.3287 3.81 20.7338 20.7338 0 0 0 .3287 3.8105 1.9764 1.9764 0 0 0 1.3906 1.4 46.7 46.7 0 0 0 6.1454.3306 46.7 46.7 0 0 0 6.1455-.3309 1.9764 1.9764 0 0 0 1.3906-1.4 20.7338 20.7338 0 0 0 .3286-3.8102 20.7341 20.7341 0 0 0 -.3286-3.8106zm-9.0893 6.1377v-4.6542l4.0907 2.3271z" />
    </g>
  );
};

export default withIcon(IconLogoYouTube);
